import { render, staticRenderFns } from "./ztsc.vue?vue&type=template&id=43abca68&scoped=true&"
import script from "./ztsc.vue?vue&type=script&lang=js&"
export * from "./ztsc.vue?vue&type=script&lang=js&"
import style0 from "./ztsc.vue?vue&type=style&index=0&id=43abca68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43abca68",
  null
  
)

export default component.exports